import {
    Component,
    Input,
    OnInit,
    ElementRef,
    ViewChild,
    AfterViewInit,
    SimpleChanges,
    OnChanges,
} from "@angular/core";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import {
    FormControl,
    FormGroupDirective,
    NgForm,
    ValidatorFn,
} from "@angular/forms";
import {
    MatAutocompleteSelectedEvent,
    MatAutocomplete,
} from "@angular/material/autocomplete";
import { MatChipInputEvent, MatChipListbox } from "@angular/material/chips";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ErrorStateMatcher } from "@angular/material/core";

export class MyErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(
        control: FormControl | null,
        form: FormGroupDirective | NgForm | null,
    ): boolean {
        const isSubmitted = form && form.submitted;
        return true;
    }
}

@Component({
    selector: "tagger",
    templateUrl: "./tagger.component.html",
    styleUrls: ["./tagger.component.scss"],
})
export class TaggerComponent implements OnInit, OnChanges, AfterViewInit {
    @Input() Tags: Array<string>;
    @Input() Label: string;
    @Input() TagControl: FormControl;
    @Input() OtherTagControl: FormControl;
    @Input() Hint?: string;
    @Input() Multi?: boolean;
    @Input() Required: boolean;
    InputControl: FormControl = new FormControl("");

    logValidator: ValidatorFn = (c) => {
        if (!c) {
            return { logValidator: true };
        } else {
            null;
        }
    };

    availableTags: string[] = [];
    filteredTags: Observable<string[]>;
    selectedTags: string[] = [];
    visible = true;
    selectable = true;
    removable = true;
    separatorKeysCodes: number[] = [ENTER, COMMA];

    @ViewChild("tagInput", { static: false })
    tagInput: ElementRef<HTMLInputElement>;
    @ViewChild("auto", { static: false }) matAutocomplete: MatAutocomplete;
    @ViewChild(MatChipListbox, { static: false }) matTagList: MatChipListbox;

    matcher = new MyErrorStateMatcher();

    ngAfterViewInit(): void {
        this.InputControl.setValue("");
    }

    ngOnInit() {
        this.availableTags = this.Tags;
        this.filteredTags = this.InputControl.valueChanges.pipe(
            map((tag: string | null) => this._filter(tag)),
        );
        if (Array.isArray(this.TagControl.value)) {
            this.selectedTags = this.TagControl.value;
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (
            changes["Tags"].currentValue &&
            changes["Tags"].currentValue.length &&
            changes["Tags"].currentValue != changes["Tags"].previousValue
        ) {
            this.availableTags = changes["Tags"].currentValue;
            this.InputControl.setValue("");
        }
    }

    add(event: MatChipInputEvent): void {
        const value = event.value;
        if ((value || "").trim()) {
            const tag = this._filter(value).toLocaleString();
            const index = this.selectedTags.findIndex((t) => t === tag);
            if (index < 0) {
                this.selectedTags.push(tag);
                this.TagControl.setValue(this.selectedTags);
                this.TagControl.updateValueAndValidity();
                this.InputControl.setValue("");
            }
        }

        this.InputControl.setValue("");
    }

    remove(tag: string): void {
        const index = this.selectedTags.indexOf(tag);

        if (index >= 0) {
            this.selectedTags.splice(index, 1);
            this.TagControl.setValue(this.selectedTags);
            this.InputControl.setValue(this.InputControl.value);
        }
    }

    selected(event: MatAutocompleteSelectedEvent): void {
        if (!this.Multi) this.selectedTags = [];
        if (!this.selectedTags.includes(event.option.viewValue)) {
            this.selectedTags.push(event.option.viewValue);
            this.TagControl.setValue(this.selectedTags);
        }

        this.tagInput.nativeElement.value = "";
        this.InputControl.setValue("");
        this.InputControl.setValue("");
    }

    isOtherTagSelected() {
        return this.selectedTags.some((x) => x === "Other");
    }

    private _filter(value: string | null): string[] {
        let filterValue = "";
        if (value) {
            filterValue = value.toLowerCase();
        }

        return (
            this.availableTags &&
            this.availableTags.filter(
                (tag) =>
                    tag.toLowerCase().indexOf(filterValue) === 0 &&
                    !this.selectedTags.includes(tag),
            )
        );
    }
}
